import { useSelector } from 'react-redux';
import { filter, map } from 'lodash-es';

import { getValidEmailsStore } from '@/store/validemails/actions';
import { isEmailVerified } from '../helpers';
import { useGetDefaultSender } from './useGetDefaultSender';

export const useGetVerifiedEmails = (): string[] => {
    const { emails } = useSelector(getValidEmailsStore);
    const defaultSender = useGetDefaultSender();
    const verifiedEmails = filter(emails, (email) => isEmailVerified(email) && email.Email !== defaultSender?.email);
    const emailsNames = map(verifiedEmails, (email) => email.Email);

    return [defaultSender?.email, ...emailsNames];
};
